import {ColorSchemeType} from 'platform/components';
import {match} from 'ts-pattern';

import {InspectionState} from '@dms/api/core';

export const getStatusColorScheme = (status: string): ColorSchemeType =>
  match<string, ColorSchemeType>(status)
    .with(InspectionState.IN_PROGRESS, () => 'blue')
    .with(InspectionState.FINISHED_AUDIT, () => 'green')
    .otherwise(() => 'orange');
